import * as React from 'react';
import { Helmet } from 'react-helmet';

type Props = {
  pathname: string;
};

const VALIDATION_TOKENS: { [pathname: string]: string } = {
  '/campus/': 'hazTPRAfpxUbT04XDNWnZLfRv-m56VIJMMepMPrcemU',
  '/government': 'hazTPRAfpxUbT04XDNWnZLfRv-m56VIJMMepMPrcemU',
};

function GoogleSiteValidation({ pathname }: Props) {
  const token = VALIDATION_TOKENS[pathname];
  if (!token) return null;

  return (
    <Helmet>
      <meta name="google-site-verification" content={token} />
    </Helmet>
  );
}

export default GoogleSiteValidation;
